import apiClient from "@/services/api-base";

const Permissoes = {
  //Sistemicas/temporarias
  AllLoggedUsers: "allLoggedUsers",

  Configuracoes: "1",
  ParametrosDadosEmpresa: "1.1",
  ParametrosEnderecosDestinacao: "1.2",
  ParametrosTiposCacamba: "1.3",
  ParametrosDiasTurnos: "1.4",
  ParametrosTipoCarroceria: "1.5",
  LogsAuditoria: "1.6",
  
  PapeisFuncoes: "1.7",
  VisualizarPapeisFuncoes: "1.7.1",
  EditarPapeisFuncoes: "1.7.2",
  CriarPapeisFuncoes: "1.7.3",
  ExcluirPapeisFuncoes: "1.7.4",
  
  TiposResiduos: "1.8",
  VisualizarResiduos: "1.8.1",
  EditarResiduos: "1.8.2",
  CriarResiduos: "1.8.3",
  ExcluirResiduos: "1.8.4",

  ModuloCadastros: "2",

  Usuarios: "2.1",
  VisualizarUsuarios: "2.1.1",
  EditarUsuarios: "2.1.2",
  CriarUsuarios: "2.1.3",
  ExcluirUsuarios: "2.1.4",
  AlterarSenhaUsuarios: "2.1.5",

  Clientes: "2.4",
  VisualizarClientes: "2.4.1",
  EditarClientes: "2.4.2",
  CriarClientess: "2.4.3",

  Veiculos: "2.5",
  VisualizarVeiculos: "2.5.1",
  EditarVeiculos: "2.5.2",
  CriarVeiculos: "2.5.3",

  Cacambas: "2.6",
  VisualizarCacambas: "2.6.1",
  EditarCacambas: "2.6.2",
  CriarCacambas: "2.6.3",
  ExcluirCacambas: "2.6.4",

  Motoristas: "2.8",
  VisualizarMotoristas: "2.8.1",
  EditarMotoristas: "2.8.2",
  CriarMotoristas: "2.8.3",
  ExcluirMotoristas: "2.8.4",

  Locacoes: "3",
  VisualizarLocacoes: "3.1",
  NovaLocacao: "3.2",
  EditarLocacoes: "3.3",

  Roteirizacao: "4",
  VisualizarRoteirizacao: "4.1",
  NovaRoteirizacao: "4.2",
  EditarRoteirizacao: "4.3",

  Operacao: "5",
  OperacaoDashboard: "5.1",
  OperacaoRegistarOp: "5.2",
  OperacaoEditarOps: "5.3",
  OperacaoFilaIntegracao: "5.4"

};

export const getMenu = async () => {
  const response = await apiClient.get("me/menu");

  let menu = [
    {
      id: 0,
      codigo: "home",
      label: "Home",
      icon: "fas fa-home",
      link: "/",
      routes: ["home"],
      subItems: null,
    },
  ];

  menu = [...menu, ...response.data.menuItens];

  return menu;
};

export default Permissoes;
